<script>
    export let building;
</script>

<span class="font-bold text-primary-500 whitespace-nowrap">
    {building.name}
</span>
